export default "__VITE_ASSET__b0f9c8cd__"